import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApContentModule } from '@ap/content';
import { ApModalComponent } from '@ap/modal';
import { LogoutModule } from '@ap/tokens-browser';

import { LogoutModalComponent } from './logout-modal.component';

/**
 * @ngdoc module
 * @name LogoutModalModule
 **/
@NgModule({
    declarations: [LogoutModalComponent],
    imports: [CommonModule, ApContentModule, LogoutModule, ApModalComponent]
})
export class LogoutModalModule {}
